import { MatPaginatorIntlEn } from './en-paginator';

export function createPaginatorLabel() {
    return new MatPaginatorIntlEn();
}
